/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { Card, CardContent, Chip, Divider, Grid, Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomDropDown from '../../shared/CustomDropDown';
import CustomSwitch from '../../shared/CustomSwitch';

const useStyles = makeStyles((theme) => ({
  conditionContainer: {
    height: '82px',
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #E4E7EC',
    marginTop: theme.spacing(2),
  },
  orCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '15px',
    lineHeight: '20px',
    margin: `${theme.spacing(2)}px 0`,
  },
  chip: {
    margin: theme.spacing(0.5),
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16.8px',
    color: '#667085',
  },
  innerCard: {
    width: '350px',
    borderRadius: '8px',
    border: '1px solid #E4E7EC',
    boxShadow: 'none',
  },
}));

export const Rule = ({
  rules,
  conditions,
  rule,
  setData,
  setConditions,
  mandatoryRuleCoditions,
  setMandatoryRuleCoditions,
}) => {
  const classes = useStyles();
  const [selectedRule, setSelectedRule] = useState(null);

  useEffect(() => {
    const value = rules?.find((r) => r.id === rule);
    setSelectedRule(value?.name);
  }, [rule, rules]);

  const handleRuleSelect = ({ target: { value: selectedValue } }) => {
    const value = rules?.find((r) => r.id === selectedValue);
    const name = 'rule';
    setData((prev) => ({ ...prev, [name]: value?.id }));
    setSelectedRule(value?.name);
    const cond = rules?.find((r) => r.id === selectedValue)?.conditions;
    setConditions(cond);
    setMandatoryRuleCoditions({});
  };
  const setMandatoryFn = ({ target: { name, checked } }) => {
    const roleId = parseInt(name, 10);
    if (checked) {
      setMandatoryRuleCoditions({ ...mandatoryRuleCoditions, [roleId]: true });
    } else {
      const updated = { ...mandatoryRuleCoditions };
      delete updated[roleId];
      setMandatoryRuleCoditions(updated);
    }
  };
  return (
    <Grid container direction="column">
      <Grid item>
        <CustomPopupText text="Select Rule" required />
      </Grid>

      <Grid item>
        <Grid container direction="row">
          <Grid item xs={6}>
            <CustomDropDown
              list={rules}
              height="44px"
              width="482px"
              name="rule"
              handleChange={handleRuleSelect}
              value={selectedRule}
            />
          </Grid>
        </Grid>
      </Grid>

      {conditions && (
        <Grid item xs={12} className={classes.conditionContainer}>
          <Card sx={{ width: '100%' }}>
            <CardContent>
              {conditions?.map((item, i) => (
                <React.Fragment key={i}>
                  <Grid container direction="row" justifyContent="flex-start" spacing={2} alignItems="center">
                    {item?.condition?.map((conditionArray, index) => (
                      <React.Fragment key={index}>
                        <Grid item>
                          <Card className={classes.innerCard}>
                            <CardContent>
                              {conditionArray.map((chip, chipIndex) => (
                                <React.Fragment key={chip?.id || chipIndex}>
                                  <Chip label={chip?.name} className={classes.chip} />
                                  {chipIndex < conditionArray.length - 1 && (
                                    <Typography
                                      sx={{ display: 'inline', margin: '0 10px', fontSize: '10px', fontWeight: 700 }}
                                    >
                                      OR
                                    </Typography>
                                  )}
                                </React.Fragment>
                              ))}
                            </CardContent>
                          </Card>
                        </Grid>

                        {index !== item?.condition?.length - 1 && (
                          <Grid item>
                            <Typography sx={{ display: 'inline', margin: '0 10px' }}>AND</Typography>
                          </Grid>
                        )}
                      </React.Fragment>
                    ))}
                  </Grid>

                  <Grid container justifyContent="flex-end" sx={{ marginTop: '8px' }} spacing={1}>
                    <Grid item>
                      <CustomPopupText text="Is Mandatory" />
                    </Grid>
                    <Grid item>
                      <CustomSwitch
                        name={item.id.toString()}
                        checked={!!mandatoryRuleCoditions?.[item.id]}
                        handleChange={setMandatoryFn}
                      />
                    </Grid>
                  </Grid>

                  {i < conditions.length - 1 && (
                    <div className={classes.orCondition}>
                      <Grid container justifyContent="center">
                        <Divider sx={{ width: '100%' }}>OR</Divider>
                      </Grid>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};
